import { ASSET_TYPES } from 'src/services/constants';

const routes = [
  {
    name: 'default',
    path: '/default', // should never get used
  },
  {
    path: '/app',
    redirect: '/',
  },
  {
    path: '/dl',
    redirect: '/',
  },
  {
    path: '/support/:accountId',
    name: 'support',
  },
  {
    path: '/',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'map',
        component: () => import('pages/Map.vue'),
      },
      {
        path: 'selected/:key',
        name: 'map-selected',
        component: () => import('pages/Map.vue'),
      },
      {
        path: 'selected/:key/previews',
        name: 'map-previews',
        component: () => import('pages/Map.vue'),
      },
      {
        path: 'nearby',
        name: 'nearby',
        component: () => import('pages/Map.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['vehicleListView'],
      label: 'Live Map',
      searchContext: ['live-map'],
    },
  },
  {
    path: '/vehicle/:key',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'vehicle',
        component: () => import('pages/Vehicle.vue'),
        meta: { permission: ['vehicleDetailsView'] },
      },
      {
        path: 'trips/:date?',
        name: 'vehicleTrips',
        component: () => import('pages/Vehicle.vue'),
        meta: { permissions: ['livemapTripsView'] },
      },
      {
        path: 'health',
        name: 'vehicleHealth',
        component: () => import('pages/Vehicle.vue'),
        meta: { permissions: ['vehicleDetailsView'] },
      },
      {
        path: 'maintenance',
        name: 'vehicleMaintenance',
        component: () => import('pages/Vehicle.vue'),
        meta: { mobileTitle: 'Maintenance', permissions: ['vehicleMaintenanceView'] },
      },
      {
        path: 'edit',
        name: 'vehicleEdit',
        component: () => import('pages/Vehicle.vue'),
        meta: { permissions: ['vehicleEdit'] },
      },
    ],
    meta: {
      auth: true,
      permissions: [],
      searchPriority: ASSET_TYPES.VEHICLE,
      searchContext: ['vehicle', 'asset'],
    },
  },
  {
    path: '/asset/:key',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'asset',
        component: () => import('pages/Asset.vue'),
        meta: { permission: ['vehicleDetailsView'] },
      },
      {
        path: 'locations/:date?',
        name: 'assetLocations',
        component: () => import('pages/Asset.vue'),
        meta: { permission: ['livemapTripsView'] },
      },
    ],
    meta: {
      auth: true,
      permissions: ['assetView'],
      searchPriority: ASSET_TYPES.ASSET,
      searchContext: ['asset', 'vehicle'],
    },
  },
  { path: '/vehicle', redirect: '/vehicles-assets' },
  { path: '/vehicles', redirect: '/vehicles-assets' },
  { path: '/asset', redirect: '/vehicles-assets' },
  { path: '/assets', redirect: '/vehicles-assets' },
  {
    path: '/vehicles-assets',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'vehiclesAssets',
        component: () => import('pages/VehiclesAssets.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['vehicleListView'],
      searchContext: ['vehicle', 'asset'],
    },
  },
  {
    path: '/places',
    component: () => import('layouts/Default.vue'),
    children: [
      { path: '', name: 'places', meta: {}, component: () => import('pages/Places.vue') },
      {
        path: ':key',
        name: 'editPlace',
        component: () => import('pages/Places.vue'),
      },
      {
        path: ':key/visits',
        name: 'placeVisits',
        component: () => import('pages/Places.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['placeListView'],
      searchPriority: 'place',
      searchContext: ['place'],
    },
  },
  {
    path: '/tags',
    component: () => import('layouts/Default.vue'),
    children: [{ path: '', name: 'tags', meta: {}, component: () => import('pages/Tags.vue') }],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['tagListView'],
    },
  },
  {
    path: '/groups',
    component: () => import('layouts/Default.vue'),
    children: [{ path: '', name: 'groups', meta: {}, component: () => import('pages/Groups.vue') }],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['groupListView'],
    },
  },
  {
    path: '/subscriptions',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        meta: { mobileTitle: 'Billing & Subscriptions' },
        name: 'subscriptions',
        component: () => import('pages/Subscriptions.vue'),
      },
      {
        path: ':subId/change-auto-renew',
        name: 'changeAutoRenew',
        component: () => import('pages/Subscriptions.vue'),
      },
    ],
    meta: {
      auth: true,
      permissions: ['accountView', 'isAccountAdmin'],
    },
  },
  {
    path: '/users',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: ':user?',
        name: 'users',
        meta: {},
        component: () => import('pages/Users.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['userListView'],
      searchPriority: 'user',
      searchContext: ['user'],
    },
  },
  {
    path: '/notifications',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'notifications',
        meta: {},
        component: () => import('pages/Notifications.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['notificationsView'],
    },
  },
  {
    path: '/dashboard',
    component: () => import('layouts/Default.vue'),
    children: [{ path: '', name: 'dashboard', component: () => import('pages/Dashboard.vue') }],
    meta: {
      auth: true,
      permissions: ['dashboardFleetOrRentalView'],
    },
  },
  {
    path: '/reports',
    component: () => import('layouts/Default.vue'),
    children: [{ path: '', name: 'reports', component: () => import('pages/Reports.vue') }],
    meta: {
      auth: true,
      permissions: ['reportListView'],
    },
  },
  {
    path: '/metabase',
    component: () => import('layouts/Default.vue'),
    children: [
      { path: '', name: 'metabase-full-app', component: () => import('pages/Metabase.vue') },
      { path: ':type/:id', name: 'metabase-signed', component: () => import('pages/Metabase.vue') },
    ],
    meta: {
      auth: true,
      permissions: ['reportListView'],
    },
  },
  {
    path: '/apps',
    component: () => import('layouts/Default.vue'),
    children: [
      { path: '', meta: { mobileTitle: 'Apps Marketplace' }, name: 'apps', component: () => import('pages/Apps.vue') },
      {
        path: ':appNameUrl',
        name: 'appDetails',
        component: () => import('pages/Apps.vue'),
        meta: {
          permissions: ['appEdit'],
        },
      },
    ],
    meta: {
      auth: true,
      permissions: ['appsListView'],
    },
  },
  {
    path: '/frame',
    name: 'iframes',
    component: () => import('layouts/MinimalTransparent.vue'),
    children: [
      {
        path: 'app-configure-capacitor/:appNameUrl',
        name: 'appConfigureCapacitor',
        component: () => import('pages/ConfigureClientAppCapacitor.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
      {
        path: 'app-configure-web/:appNameUrl',
        name: 'appConfigureWeb',
        component: () => import('pages/ConfigureClientAppWeb.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
    ],
    meta: {
      auth: false,
    },
  },
  {
    path: '/devices',
    component: () => import('layouts/Default.vue'),
    children: [
      { path: '', name: 'devices', meta: {}, component: () => import('pages/Devices.vue') },
      {
        path: 'asset',
        name: 'assetDevices',
        meta: {},
        component: () => import('pages/Devices.vue'),
        children: [
          {
            path: 'connect/:serial',
            name: 'deviceConnect',
            component: () => import('pages/Devices.vue'),
            meta: { permissions: [] },
          },
        ],
      },
      { path: 'dashcam', name: 'dashcamDevices', meta: {}, component: () => import('pages/Devices.vue') },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['deviceListView'],
    },
  },
  {
    path: '/serial/:serial', // from qr.zubie.com
    redirect: (to) => `/devices/asset/connect/${to.params.serial}`,
  },
  {
    path: '/asset-recovery',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        meta: { mobileTitle: 'Recover Your Missing/Stolen Vehicle' },
        name: 'assetRecovery',
        component: () => import('pages/AssetRecovery.vue'),
      },
    ],
    meta: {
      auth: true,
      permissions: ['assetRecoveryView'],
    },
  },
  {
    path: '',
    component: () => import('layouts/Auth.vue'),
    children: [
      {
        path: '/select-account',
        name: 'selectAccount',
        component: () => import('pages/SelectAccount.vue'),
        meta: { auth: true },
      },
      { path: '/login', name: 'login', component: () => import('pages/Login.vue') },
      {
        path: '/logout',
        name: 'logout',
        component: () => import('pages/Logout.vue'),
        meta: {
          auth: false,
        },
      },
      {
        path: '/reset-password',
        name: 'resetPassword',
        component: () => import('pages/ResetPassword.vue'),
      },
      {
        path: '/create-account',
        name: 'createAccount',
        component: () => import('pages/CreateAccount.vue'),
      },
      {
        path: '/setup-account',
        name: 'setupAccount',
        component: () => import('pages/SetupAccount.vue'),
        meta: {
          auth: true,
        },
      },
      { path: '/invite', name: 'invite', component: () => import('pages/Invite.vue') },
      {
        path: '/invite/welcome',
        name: 'inviteWelcome',
        component: () => import('pages/InviteWelcome.vue'),
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: '/attributions',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        meta: { mobileTitle: 'Attributions' },
        name: 'attributions',
        component: () => import('pages/Attributions.vue'),
      },
    ],
    meta: {
      auth: true,
      permissions: [],
    },
  },
  { path: '/asset-type', redirect: '/asset-types' },
  {
    path: '/asset-types',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'assetTypes',
        meta: {},
        component: () => import('pages/AssetTypes.vue'),
      },
    ],
    meta: {
      auth: true,
      hasUniversalSearchFiltering: true,
      permissions: ['assetView'],
    },
  },
  {
    path: '/video-download',
    component: () => import('layouts/Minimal.vue'),
    children: [
      {
        path: '/',
        name: 'video-download',
        component: () => import('pages/VideoDownload.vue'),
        meta: {
          auth: false,
        },
      },
    ],
    meta: {
      auth: false,
    },
  },
  {
    path: '/video-stream/:serial',
    component: () => import('layouts/Minimal.vue'),
    children: [
      {
        path: '/',
        name: 'video-stream',
        component: () => import('pages/VideoStream.vue'),
        meta: {
          auth: false,
        },
      },
    ],
    meta: {
      auth: true,
    },
  },
  {
    path: '/check-in',
    component: () => import('layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'checkIn',
        component: () => import('pages/CheckIn.vue'),
      },
    ],
    meta: {
      auth: true,
    },
  },
  {
    component: () => import('layouts/Default.vue'),
    path: '',
    children: [
      {
        name: 'app-boot-failure',
        path: '',
        component: () => import('pages/AppBootFailure.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
      {
        name: 'incompatible',
        path: '',
        component: () => import('pages/Incompatible.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
      {
        name: 'loading',
        path: '/loading',
        component: () => import('pages/Loading.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
    ],
  },
  {
    path: '',
    component: () => import('layouts/Minimal.vue'),
    children: [
      {
        name: 'invalid-session',
        path: '',
        component: () => import('pages/InvalidSession.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
    ],
  },
  {
    path: '',
    component: () => import('layouts/Minimal.vue'),
    children: [
      {
        name: 'no-accounts',
        path: 'no-accounts',
        component: () => import('pages/NoAccounts.vue'),
        meta: {
          auth: false,
          permissions: [],
        },
      },
    ],
  },
  {
    path: '/denied',
    component: () => import('layouts/Default.vue'),
    children: [{ path: '', name: 'denied', component: () => import('pages/Denied.vue') }],
  },
];

// Always leave this as last one
routes.push({
  path: '*',
  component: () => import('pages/Error404.vue'),
});

export default routes;
